import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTruckBody = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 20.7C11.1 20.7 12 19.8 12 18.7C12 17.6 11.1 16.7 10 16.7C8.9 16.7 8 17.6 8 18.7C8 19.8 8.9 20.7 10 20.7Z",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 20.7C19.1 20.7 20 19.8 20 18.7C20 17.6 19.1 16.7 18 16.7C16.9 16.7 16 17.6 16 18.7C16 19.8 16.9 20.7 18 20.7Z",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.19995 20.7C5.29995 20.7 6.19995 19.8 6.19995 18.7C6.19995 17.6 5.29995 16.7 4.19995 16.7C3.09995 16.7 2.19995 17.6 2.19995 18.7C2.19995 19.8 3.09995 20.7 4.19995 20.7Z",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 18V6.59998C1 6.29998 1.2 6.09998 1.5 5.89998C1.8 5.69998 2.2 5.59998 2.7 5.59998H20V12V17M23 17H21M6.5 18H7M13 18L16 18M21 17L20 18.5V17M21 17H20",
			stroke: "CurrentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTruckBody;
